import { RightSideDefaultClassName } from 'app/src/features/Shopping/shared/utils'
import { refundApi, shoppingApi } from 'app/src/services/welfareportal'
import { FringeBenefitSpinner } from 'app/src/shared/components'
import { euroFormatterIt } from 'app/src/shared/helpers'
import { useTranslation } from 'react-i18next'

export function RefundRightPanelSide(props: {
  refund: refundApi.Refund
  requestedRefund?: number
  className?: string
  funnelMode?: boolean
}) {
  const creditApiResponse = shoppingApi.useCreditGet(
    {},
    {
      enabled: typeof props.funnelMode !== 'undefined' && props.funnelMode,
      meta: {
        skip404Errors: true,
      },
    },
  )
  const { t } = useTranslation('shopping', { keyPrefix: 'Refund' })

  return (
    <div className={props.className ?? RightSideDefaultClassName}>
      <div className='col-span-12 mx-auto pl-12 lg:col-span-6 lg:pl-0'>
        {props.requestedRefund && (
          <>
            <div className='h-[28px]'>{t('priceDescription')}</div>
            <div className='mt-4 text-2xl font-bold'>{euroFormatterIt.format(props.requestedRefund)}</div>
            {typeof props.funnelMode !== 'undefined' && props.funnelMode && (
              <div className='mt-4'>
                {t('balanceDescription', {
                  AVAILABLECREDIT: creditApiResponse.data?.creditByServiceCategory?.welfareArt100.available
                    ? euroFormatterIt.format(creditApiResponse.data.creditByServiceCategory.welfareArt100.available)
                    : '-',
                })}
              </div>
            )}
          </>
        )}
      </div>
      {typeof props.refund?.attributes?.limitType !== 'undefined' &&
        props.refund.attributes.limitType === 'welfareArt51' &&
        typeof props.funnelMode !== 'undefined' &&
        props.funnelMode && (
          <div className='col-span-12 lg:col-span-6 lg:pl-6'>
            <FringeBenefitSpinner pt={{ title: { hide: true } }} />
          </div>
        )}
    </div>
  )
}
